// ################ HELPER CLASS ################
class SetX {
  // NOT EFF. IN STORAGE IF DIST. BETWEEN AN ELEMENT 'a' and 'b' IS BIGGER THEN INTEGER-BITS

  constructor(cpy) {
    if (cpy instanceof SetX) {
      this.array = cpy.array.slice();
    } else {
      this.array = [];
    }
  }

  add(element) {
    const arrayIndex = element >>> 5;
    const elementIndex = 1 << (element & 31);
    if (this.array.length > arrayIndex) {
      this.array[arrayIndex] |= elementIndex;
    } else {
      Array.prototype.push.apply(
        this.array,
        new Uint32Array(arrayIndex + 1 - this.array.length).fill(0)
      );
      this.array[arrayIndex] = elementIndex;
    }
  }

  static intersectionIsNotEmpty(lhs, rhs) {
    const a = lhs.array;
    const b = rhs.array;
    const size = a.length < b.length ? a.length : b.length;

    for (let i = 0; i < size; ++i) {
      if ((a[i] & b[i]) !== 0) {
        return true;
      }
    }
    return false;
  }

  static intersection(lhs, rhs) {
    let b;
    let ret;

    if (lhs.array.length < rhs.array.length) {
      b = rhs.array;
      ret = new SetX(lhs);
    } else {
      b = lhs.array;
      ret = new SetX(rhs);
    }
    for (let i = ret.array.length - 1; -1 < i; --i) {
      ret.array[i] &= b[i];
    }
    return ret;
  }

  static union(lhs, rhs) {
    let b;
    let ret;

    if (rhs.array.length < lhs.array.length) {
      b = rhs.array;
      ret = new SetX(lhs);
    } else {
      b = lhs.array;
      ret = new SetX(rhs);
    }

    const size = b.length;
    for (let i = 0; i < size; ++i) {
      ret.array[i] |= b[i];
    }

    return ret;
  }
}

class NodeX {
  constructor(ref, col) {
    if (ref instanceof NodeX) {
      this.r = ref.refs.slice();
      this.e = new SetX(ref.edges);
      this.color = ref.color;
    } else {
      this.r = [ref];
      this.e = new SetX();
      this.color = col
        ? col
        : "#" +
          Math.floor(Math.random() * 16).toString(16) +
          Math.floor(Math.random() * 16).toString(16) +
          Math.floor(Math.random() * 16).toString(16) +
          Math.floor(Math.random() * 16).toString(16) +
          Math.floor(Math.random() * 16).toString(16) +
          Math.floor(Math.random() * 16).toString(16);
    }
  }

  addRef(ref) {
    this.r.push(ref);
  }

  addEdge(edge) {
    this.e.add(edge);
  }

  get edges() {
    return this.e;
  }

  get refs() {
    return this.r;
  }
}

function strToHexColor(str) {
  let hash = 10112327;

  for (let i = 0; i < str.length; ++i) {
    const chr = str.charCodeAt(i);
    hash ^= chr << (i * 8) % 24;
  }
  const r1 = hash & ((1 << 4) - 1);
  const r2 = (hash & ((1 << 8) - 1)) >>> 4;
  const g1 = (hash & ((1 << 12) - 1)) >>> 8;
  const g2 = (hash & ((1 << 16) - 1)) >>> 12;
  const b1 = (hash & ((1 << 20) - 1)) >>> 16;
  const b2 = (hash & ((1 << 24) - 1)) >>> 20;

  const color =
    "#" +
    r1.toString(16) +
    r2.toString(16) +
    g1.toString(16) +
    g2.toString(16) +
    b1.toString(16) +
    b2.toString(16);
  return color;
}
